var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_1864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.04561 1.36742L22.5558 10.1271C23.3287 10.4741 23.3469 11.5648 22.5861 11.9374L2.97002 21.5453C2.08113 21.9807 1.16765 20.9983 1.66637 20.1434L6.69287 11.5265C6.88149 11.2032 6.87372 10.8016 6.67275 10.4858L1.79236 2.81656C1.25952 1.97924 2.1402 0.960906 3.04561 1.36742Z",
    fill: "#D6D6D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_1864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIconWhite);
export default __webpack_public_path__ + "static/media/input-icon-white.72e731da12f3f8b1362fa28a594ceeff.svg";
export { ForwardRef as ReactComponent };